import {DashboardPageLink} from './DashboardPage';
import {PriceQuotesPageLink} from './PriceQuotesPage';
import {OrdersPageLink} from './OrdersPage';
import {OrderDetailsLink} from './OrderDetails';
import {InspectionsPageLink} from './InspectionsPage';
import {CustomersEntityLink} from './CustomersEntity';
import {OldInspectionDetailsLink} from './OldInspectionDetails';
import {InspectionDetailsLink} from './InspectionDetails';
import {CustomerDetailsLink} from './CustomerDetails';
import {TasksLink} from './TasksPage';
import {UsersActionsLink} from './UsersActions';
import {ContactsLink} from './ContactsPage';
import {InspectionsMapLink} from './InspectionsMap';
import {PriceQuoteDetailsLink} from './PriceQuoteDetails';
import {PriceCatalogLink} from './PriceCatalogPage';
import {NotificationsLink} from './NotificationsPage';

export default [
  DashboardPageLink,
  PriceQuotesPageLink,
  PriceQuoteDetailsLink,
  OrdersPageLink,
  OrderDetailsLink,
  TasksLink,
  InspectionsPageLink,
  InspectionDetailsLink,
  InspectionsMapLink,
  OldInspectionDetailsLink,
  CustomersEntityLink,
  CustomerDetailsLink,
  ContactsLink,
  PriceCatalogLink,
  NotificationsLink,
  UsersActionsLink
];
